
	import { defineComponent, ref, getCurrentInstance, onMounted, reactive } from 'vue'
	// import { useTableScroll } from '@/common/mixins/useTableScroll'
	// import { UsePageDto } from '@/common/mixins/listPageDto'
	import handleStartTime from 'library/functions/handleStartTime'
	import handleEndTime from 'library/functions/handleEndTime'
	import { nameOptions } from './config'
	import formatDate from '@/common/functions/formatDate'
	import { getBugsList, getNameList, sendMail } from './request'
	import { message } from 'ant-design-vue'
	// import hanzi2pinyin from 'wd-hanzi2pinyin'
	type TableDataType = {
		totalBug: number
		levelBug: number
		openedBug: number
		totalProdBug: number
		levelProdBug: number
		totalSmokeBug: number
		levelRate: string
		openedRate: string
		levelProdRate: string
	}

	const columns = [
		{
			title: '姓名',
			dataIndex: 'userName',
			key: 'userName',
			fixed: 'left',
			width: 90
		},
		{
			title: '非线上Bug总数',
			dataIndex: 'totalBug',
			key: 'totalBug',
			width: 150,
			sorter: (a: TableDataType, b: TableDataType) => a.totalBug - b.totalBug
		},
		{
			title: '非线上Bug高优总数',
			dataIndex: 'levelBug',
			key: 'levelBug',
			width: 180,
			sorter: (a: TableDataType, b: TableDataType) => a.levelBug - b.levelBug
		},
		{
			title: '非线上Bug高优占比',
			dataIndex: 'levelRate',
			key: 'levelRate',
			width: 180,
			sorter: (a: TableDataType, b: TableDataType) => parseFloat(a.levelRate) - parseFloat(b.levelRate)
		},
		{
			title: '非线上Bug打开总数',
			dataIndex: 'openedBug',
			key: 'openedBug',
			width: 180,
			sorter: (a: TableDataType, b: TableDataType) => a.openedBug - b.openedBug
		},
		{
			title: '非线上Bug打开占比',
			dataIndex: 'openedRate',
			key: 'openedRate',
			width: 180,
			sorter: (a: TableDataType, b: TableDataType) => parseFloat(a.openedRate) - parseFloat(b.openedRate)
		},
		{
			title: '线上Bug总数',
			dataIndex: 'totalProdBug',
			key: 'totalProdBug',
			width: 140,
			sorter: (a: TableDataType, b: TableDataType) => a.totalProdBug - b.totalProdBug
		},
		{
			title: '线上Bug高优总数',
			dataIndex: 'levelProdBug',
			key: 'levelProdBug',
			width: 170,
			sorter: (a: TableDataType, b: TableDataType) => a.levelProdBug - b.levelProdBug
		},
		{
			title: '线上Bug高优占比',
			dataIndex: 'levelProdRate',
			key: 'levelProdRate',
			width: 170,
			sorter: (a: TableDataType, b: TableDataType) => parseFloat(a.levelProdRate) - parseFloat(b.levelProdRate)
		},
		{
			title: '冒烟Bug总数',
			dataIndex: 'totalSmokeBug',
			key: 'totalSmokeBug',
			width: 135,
			sorter: (a: TableDataType, b: TableDataType) => a.totalSmokeBug - b.totalSmokeBug
		}
	]

	export default defineComponent({
		setup() {
			let formState = reactive({
				userName: '',
				timeRange: [
					formatDate(new Date(Date.now() - 30 * 24 * 3600 * 1000), 'YYYY-MM-DD'),
					formatDate(new Date(), 'YYYY-MM-DD')
				],
				userId: ''
			})

			const data = ref([])
			const dataSource = ref([])
			const loading = ref(false)
			const visible = ref<Boolean>(false)
			const instance = getCurrentInstance()
			let isSearchError = ref<Boolean>(false)

			//获取列表
			const fetchList = async () => {
				let idArr: any = []

				let params = {
					userId: ''
				}

				// //输入字母搜索
				// if (dataSource.value.length !== 0) {
				// 	dataSource.value.forEach((item: { id: string; name: string }) => {
				// 		if (
				// 			item.name.indexOf(formState.userName) ||
				// 			hanzi2pinyin
				// 				.parse(item.name)
				// 				.map((item) => item.target.toLowerCase())
				// 				.join('')
				// 				.indexOf(formState.userName)
				// 		) {
				// 			idArr.push(item.id)
				// 		}
				// 	})
				// }

				if (dataSource.value.length !== 0) {
					dataSource.value.forEach((item: { id: string; name: string; login: string }) => {
						idArr.push(item.id)
					})
				}
				params = {
					userId: idArr.length ? idArr : ''
				}

				let timeRange: any = formState.timeRange
				if (timeRange) {
					Object.assign(params, {
						startDate: handleStartTime(new Date(timeRange[0])),
						endDate: handleEndTime(new Date(timeRange[1]))
					})
				}
				loading.value = true
				try {
					const res = await getBugsList(params)
					loading.value = false
					data.value = isSearchError.value ? [] : res.data
				} catch (e) {
					// console.error(e)
					loading.value = false
				}
				loading.value = false
			}

			//导出
			const exportExcel = async () => {
				let idArr: any = []

				let params = {
					userId: '',
					startDate: 0,
					endDate: 0
				}
				data.value.forEach((item: { id: string; name: string; login: string }) => {
					idArr.push(item.id)
				})

				params.userId = JSON.stringify(idArr)

				let timeRange: any = formState.timeRange
				if (timeRange) {
					Object.assign(params, {
						startDate: handleStartTime(new Date(timeRange[0])),
						endDate: handleEndTime(new Date(timeRange[1]))
					})
				}
				console.log(params)
				loading.value = true

				let url = `/getFile.py?userId=${params.userId}&startDate=${params?.startDate}&endDate=${params?.endDate}`
				const aDom = document.createElement('a')
				// aDom.download = 'bugs统计表.xlsx' // 设置下载的文件名
				aDom.href = url
				document.body.appendChild(aDom)
				aDom.click()
				aDom.remove()

				loading.value = false
			}

			//发送邮件
			const sendEmail = async () => {
				let idArr: any = []

				let params = {
					userId: '',
					recviers: ''
				}

				dataSource.value.forEach((item: { id: string; name: string; login: string }) => {
					if (item.name.includes(formState.userName) || item.login.includes(formState.userName)) {
						idArr.push(item.id)
					}
				})

				params.userId = idArr.length ? idArr : ''

				let timeRange: any = formState.timeRange
				if (timeRange) {
					Object.assign(params, {
						startDate: handleStartTime(new Date(timeRange[0])),
						endDate: handleEndTime(new Date(timeRange[1]))
					})
				}
				loading.value = true
				try {
					const res = await sendMail(params)
					loading.value = false
					visible.value = false
					message.success('发送成功')
				} catch (e) {
					loading.value = false
				}
			}
			const handleOk = () => {
				visible.value = true
			}

			const handleChange = (value: string) => {
				console.log(`selected ${value}`)
				fetchList()
			}
			// const handleTableChange = (sorter: any) => {
			// 	// sortField: sorter.field,
			// 	// sortOrder: sorter.order,
			// 	// ...filters
			// 	console.log(sorter)
			// }
			const onSearch = async () => {
				const params = {
					userName: formState.userName || ''
				}
				try {
					const res = await getNameList(params)
					dataSource.value = res.data
					isSearchError.value = false
				} catch (e) {
					console.error(e)
					isSearchError.value = true
				}
				fetchList()
			}
			// 时间限制范围 结束时间不能超过今天 跨度90天
			// const disabledDate = (current: Date) => {
			// 	let time = new Date(current).getTime()
			// 	let endTime = handleEndTime(Date.now())
			// 	return time > endTime
			// }

			//时间初始值
			const setTime = (time: number) => {
				let timeNow = new Date(time).getTime()
				Object.assign(formState, {
					timeRange: [
						formatDate(new Date().getTime() - (timeNow - 1) * 24 * 3600 * 1000, 'YYYY-MM-DD'),
						formatDate(new Date(), 'YYYY-MM-DD')
					]
				})
			}
			onMounted(() => {
				fetchList()
				setTime(30)
			})
			return {
				columns,
				data,
				loading,
				labelCol: { span: 4 },
				formState,
				reactive,
				exportExcel,
				handleChange,
				dataSource,
				nameOptions,
				sendEmail,
				onSearch,
				isSearchError,
				visible,
				handleOk
			}
		}
	})
